import React, {useState} from 'react';
import Helmet from 'react-helmet';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import FlashMessages from './FlashMessages';
import SiteTopHeader from './SiteTopHeader';
import SiteBottomHeader from './SiteBottomHeader';

export default function SiteLayout({ children, header }) {
     const { app, auth, data } = usePage().props;
     const [userScroll, setUserScroll] = useState(false);

     window.addEventListener('scroll', function(){
          if(window.pageYOffset>200){
               setUserScroll(true);
          }else{
               setUserScroll(false);
          }
     });

     return (
          <React.Fragment key="site-layout">
               <Helmet titleTemplate={`${app.name} | %s`} />
               <div className="w-full">
                    {route().current('site') && (<div className="fixed right-0 z-50 float-right w-32 pb-3 pl-4 pr-2 bg-yellow-400 border-t border-b border-l rounded-l-full top-60 border-emerald-600">
                         <InertiaLink href={route('notebook.get.user')}>
                              <img src={app.mhd.cahierExo} className="w-full mr-8" />
                         </InertiaLink>
                    </div>)}
                    <div className="flex flex-col w-full h-screen">
                        <div className="flex w-full">
                             <SiteBottomHeader sticky={userScroll}>{header}</SiteBottomHeader>
                        </div>
                        {route().current('site') && (<div className="w-full">
                             <div className="flex w-full" style={{height: `800px`}}>
                                  <img src={app.slides.s1} alt={app.name} className="object-cover w-full" />
                             </div>
                             <div className="items-center w-full text-gray-100 md:flex bg-emerald-700 justify-content-center">
                                  <div className="w-full h-full p-6 border-b md:w-1/3 md:border-r border-emerald-800">
                                       <h1 className="text-lg font-semibold uppercase">{data.caption.pdfs.livres.text}</h1>
                                       <a href={data.caption.pdfs.livres.file} className="pt-2 hover:underline">{data.caption.download}</a>
                                  </div>

                                  <div className="w-full h-full p-6 border-b md:w-1/3 md:border-r border-emerald-800">
                                       <h1 className="text-lg font-semibold uppercase">{data.caption.pdfs.fournitures.text}</h1>
                                       <a href={data.caption.pdfs.fournitures.file} className="pt-2 hover:underline">{data.caption.download}</a>
                                  </div>

                                  <div className="w-full h-full p-6 md:w-1/3">
                                       <h1 className="text-lg font-semibold uppercase">{data.caption.pdfs.bons.text}</h1>
                                       <a href={data.caption.pdfs.bons.file} className="pt-2 hover:underline">{data.caption.download}</a>
                                  </div>
                             </div>
                        </div>)}
                        <div className={`w-full ${!userScroll?'relative':''}`}>
                             {/* To reset scroll region (https://inertiajs.com/pages#scroll-regions) add `scroll-region="true"` to div below  md:pl-4 lg:pl-10 md:pr-4 flex self-start flex-col mt-10 |  p-6 md:py-8 lg:py-12 xl:py-16 md:px-8 lg:px-12 xl:px-20 */}
                             <div className="flex flex-col w-full rounded">
                                  <FlashMessages />
                                  {children}
                             </div>
                             <div className="w-full bg-gray-300">
                                  <div className="container p-5 mx-auto text-gray-600">
                                       © 2018 Maison Henri Deschamps. {app.caption.rights}
                                  </div>
                             </div>
                        </div>
                   </div>
               </div>
          </React.Fragment>
     );
}
